const PUBLIC_SITE_BASE = String(import.meta.env.VITE_PUBLIC_SITE_URL || 'https://invinciblengo.org')
  .trim()
  .replace(/\/$/, '');

export function specialEventPublicUrl(slug) {
  const s = String(slug || '').trim();
  if (!s) return '';
  return `${PUBLIC_SITE_BASE}/special-events/${encodeURIComponent(s)}`;
}

export function getPublicSiteBase() {
  return PUBLIC_SITE_BASE;
}
